import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { storeLeadID, storeToken } from "../../utils/storage";
import useResponse from "../../hooks/useResponse";
import { useDispatch, useSelector } from "react-redux";
import { addAccountId, addRepeatCustomer, changeLoanApproved } from "../../redux/slices/userSlice";
import { showManualContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function Login() {
  const { handleStep } = useResponse();

  const { isLoanApproved } = useSelector((state) => state.user);

  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    handleUserLogin();
  }, [location.search, isLoanApproved]);

  const handleUserLogin = () => {
    dispatch(changeLoanApproved(false));
    dispatch(addAccountId(""));
    dispatch(addRepeatCustomer(false));

    setTimeout(() => {
      const queryParams = new URLSearchParams(location.search);

      const token = queryParams.get("token");
      const leadID = queryParams.get("leadID");

      if (leadID) {
        storeLeadID(leadID);
      } else {
        storeLeadID("");
      }

      if (token) {
        storeToken(token);

        if (!isLoanApproved) {
          handleStep("");
        }
      }
    }, 1000);
  };

  return (
    <div>
      {showManualContextualLoader("Logging in...")}
    </div>
  );
}
